import axios from 'axios';
import { getDefaultStore } from 'jotai';

import { API_URLS } from '../../config/api-urls';
import { Session } from '../../core/user/users.types';
import { isLoggedInAtom } from './atoms';
import { checkIfHasSessionRefreshToken } from './utils';

type RefreshResponse = {
  session: Session | null;
};

type RefreshUserAuthenticationSessionProps = {
  authenticationHeaders?: Record<string, string>;
  refreshToken?: string;
};

const refreshUserAuthenticationSession = async ({
  authenticationHeaders,
  refreshToken,
}: RefreshUserAuthenticationSessionProps = {}) => {
  const defaultStore = getDefaultStore();
  const hasRefreshCookie = checkIfHasSessionRefreshToken();
  try {
    if (!hasRefreshCookie && !authenticationHeaders) {
      throw new Error('User does not have a refresh token');
    }
    // Create singular axios instance for the refresh token
    const api = axios.create({
      baseURL: API_URLS.CORE,
      withCredentials: true,
      headers: authenticationHeaders,
    });

    const { data } = await api.put<RefreshResponse>(`/users/me`, { refresh_token: refreshToken });

    return {
      session: data.session,
    };
  } catch (error) {
    defaultStore.set(isLoggedInAtom, false);
    throw error;
  }
};

export { refreshUserAuthenticationSession };
